import React, { useState, useEffect, useContext } from 'react';
import api                 from './AxiosConfig';
import { AuthContext }     from './AuthContext';
import { BsStopwatchFill } from "react-icons/bs";

function DaysUntil90() {
  const [remainingDays, setRemainingDays]         = useState(null); // State to hold the calculated remaining days
  const [daysTill90Display, setDaysTill90Display] = useState( false );
  const { isLoggedIn, getUserId } = useContext(AuthContext);
  
  // Function to fetch the user's DOB from the backend
  useEffect(() => {
    var dob = new Date();
    const fetchDob = async () => {
      try {
        const userId = await getUserId();
        const response = await api.get(`/site/users/${encodeURIComponent(userId)}`, {withCredentials: true });
        const data = await response.data;
        if (data && data.DOB) {
            const isoDate = new Date(data.DOB);
            const formattedDate = isoDate.toISOString().split('T')[0]; // Convert to YYYY-MM-DD format
            dob = formattedDate;
        }
        if (data) {
            var daysLeft = 0;
            if (data.days_till_90_enabled === 1) {
                const dobDate = new Date(dob);
                const ninetyYearsLater = new Date(dobDate);
                ninetyYearsLater.setFullYear(dobDate.getFullYear() + 90);
                const today = new Date();
                const diffTime = ninetyYearsLater - today;
                daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            }
            setRemainingDays(daysLeft > 0 ? daysLeft : 0);
            setDaysTill90Display( data.days_till_90_enabled === 1);
        }        
      } catch (error) {
        console.error('Error fetching DOB:', error);
      }
    };

    fetchDob();
  }, [isLoggedIn, getUserId]); // Empty dependency array to run only once on component mount

  return (
    <>
      {daysTill90Display ? ( <><BsStopwatchFill />{remainingDays } </> ) : ( <> </> ) }
    </>
  );
}

export default DaysUntil90;
